import { CallDirection } from '@src/types/calls';
import { useMemo } from 'react';

export type CallDirectionFlags = {
  isCallOutgoing: boolean;
  isCallIncoming: boolean;
};

export const callDirectionFlags = (
  direction?: CallDirection
): CallDirectionFlags => ({
  isCallOutgoing: direction === CallDirection.BUSINESS_INITIATED,
  isCallIncoming: direction === CallDirection.USER_INITIATED,
});

const useCallDirectionFlags = (direction?: CallDirection): CallDirectionFlags =>
  useMemo(() => callDirectionFlags(direction), [direction]);

export default useCallDirectionFlags;
